import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotFolderMinus = ({
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                fillRule="evenodd"
                d="M17.798 6.933c-3.35.756-8.67 2.033-12.548 5.833-3.878 3.81-6.665 10.498-4.485 14.332 2.192 3.823 9.352 4.78 15.657 6.315 6.317 1.545 11.77 3.665 15.58 1.95 3.798-1.713 5.934-7.25 7.07-12.02 1.145-4.77 1.27-8.762.156-12.1-1.1-3.337-3.462-6.01-6.148-6.89-2.698-.868-5.732.046-8.127.813-2.394.766-3.795 1-7.155 1.767Z"
                clipRule="evenodd"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M15 23.333h10m11.665 8.334A3.333 3.333 0 0 1 33.332 35H6.665a3.333 3.333 0 0 1-3.333-3.333V8.333A3.333 3.333 0 0 1 6.665 5H15l3.333 5h15a3.334 3.334 0 0 1 3.333 3.333v18.334Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotFolderMinus.displayName = "SpotFolderMinus";
